import React from "react";

export default function Maintenance({ message }) {
  return (
    <div className="min-h-screen grid-noise flex items-center justify-center p-6" data-testid="maintenance-page">
      <div className="glass rounded-3xl p-10 max-w-lg text-center fade-up">
        <div className="text-gold text-4xl mb-4">◆</div>
        <h1 className="font-heading text-4xl font-bold mb-4">ARVEX</h1>
        <p className="text-gray-300 whitespace-pre-line" data-testid="maintenance-message">{message}</p>
      </div>
    </div>
  );
}
